import ZnLine from 'images/ks/zn/header-line.png'
import ZnLogo from 'images/ks/zn/header-logo.png'
import NkrLine from 'images/ks/nkr/header-line.png'
import NkrLogo from 'images/ks/nkr/header-logo.png'
import { getKsClientLowerCase } from 'utils/domain'
import React from 'react'
import styled from 'styled-components'

/**
 * 共済系用グローバルヘッダー・全ての画面に適用するヘッダー
 */
const KsGlobalHeader: React.FC = () => {

  // 現在の各共済系ドメインに応じて表示するロゴ、ヘッダー画像とスタイルを選ぶ
  const LogoImg = getKsClientLowerCase() === 'zn' ? <ZnLogoArea><ZnLogoImg src={ZnLogo} /></ZnLogoArea> : getKsClientLowerCase() === 'nkr' ? <NkrLogoArea><NkrLogoImg src={NkrLogo} /></NkrLogoArea> : ''
  const LineImg = getKsClientLowerCase() === 'zn' ? <KsLineImg src={ZnLine} /> : getKsClientLowerCase() === 'nkr' ? <KsLineImg src={NkrLine} /> : ''
  return (
    <KsArea>
        {LogoImg}
      <KsLineArea>
        {LineImg}
      </KsLineArea>
    </KsArea>
  )
}

const KsArea = styled.div`
  background: var(--color-text-for-main-background);
  width: 100%;
  height: 44px;
`

const ZnLogoArea = styled.div`
  width: 265px;
  height: 45px;
`

const ZnLogoImg = styled.img`
  width: 265px;
  height: 45px;
`

const NkrLogoArea = styled.div`
  width: 284px;
  height: 45px;
`

const NkrLogoImg = styled.img`
  width: 284px;
  height: 45px;
`

const KsLineArea = styled.div`
  width: 100%;
  height: 9px;
`

const KsLineImg = styled.img`
  width: 100%;
  height: 9px;
  vertical-align: top;
`

export default KsGlobalHeader
